import { addCopyTextListener } from '../modules/copytext'

const ShareModalContent = () => {

    const shareUrl = window.location.href

    const socialNetworks = [
        {
            name: 'facebook',
            faIcon: 'fa-facebook-square',
            url: 'https://www.facebook.com/sharer/sharer.php?u={{shareUrl}}',
            title: mb.translations["Share on Facebook"]
        },
        {
            name: 'twitter',
            faIcon: 'fa-twitter-square',
            url: 'https://twitter.com/intent/tweet?url={{shareUrl}}&amp;via=meteoblue',
            title: mb.translations["Share on Twitter"]
        },
        {
            name: 'WhatsApp',
            faIcon: 'fa-whatsapp',
            url: 'https://api.whatsapp.com/send?text={{shareUrl}}',
            title: mb.translations["Share on WhatsApp"]
        },
        {
            name: 'Telegram',
            faIcon: 'fa-telegram',
            url: 'https://telegram.me/share/url?url={{shareUrl}}',
            title: mb.translations["Share on Telegram"]
        }
    ]

    const html = 
        `<p>${mb.translations["Share link"]}</p>
        <div class="share_link_wrapper">
            <input
                id="maps_share_link"
                class="share_link_input"
                type="text"
                value="${shareUrl}"
                readonly
            >
            <button id="copy_button" class="copy_button">Copy</button>
        </div>
        <div class="share_widget">
            <a class="share_widget_link" href="/weather/widget/setupmap">
                ${mb.translations["Embed customizable widget into your own website"]}
            </a>
        </div>`

    // create content from html 
    const content = document.createElement('div')
    content.classList.add('share_modal_content')
    content.innerHTML = html

    // add event listener to "copy text" button
    const shareLinkInput = content.querySelector('#maps_share_link') as HTMLInputElement
    const copyButton = content.querySelector('#copy_button') as HTMLButtonElement
    if(shareLinkInput !== null && copyButton !== null) {
        addCopyTextListener(shareLinkInput, copyButton)
    }

    // create social share links
    const socialShareWrapper = document.createElement('div')
    socialShareWrapper.classList.add('social_share_wrapper')
    const shareUrlEncoded = encodeURIComponent(window.location.href)
    const socialShareLinks = socialNetworks.map((socialNetwork) => {
        const linkEl = document.createElement('a')
        linkEl.classList.add('share_option')
        linkEl.target = '_blank'
        linkEl.href = socialNetwork.url.replace('{{shareUrl}}', shareUrlEncoded)
        linkEl.title = socialNetwork.title

        const iconEl = document.createElement('div')
        iconEl.classList.add('fasvg-34', socialNetwork.faIcon, 'share_icon')

        linkEl.appendChild(iconEl)

        return linkEl
    })
    socialShareLinks.forEach((link) => socialShareWrapper.appendChild(link))
    content.insertBefore(socialShareWrapper, content.firstChild)

    return content
}

export { ShareModalContent }